// @flow

import * as React from 'react';
import type { GeoPillSponsorDataProvider } from '@ta/brand.sponsored-geopill';
import GeoPillSearch from '@ta/brand.geopill-search';

import TargetedFlyout from './TargetedFlyout';

/* eslint css-modules/no-unused-class: [2, { markAsUsed: ['overlayContents']}] */
import styles from './geoPillCommon.less';

type Props = {|
  children: any => React.Node,

  /**
   * Whether we should be showing the nearby option in typeahead.
   * We don't yet do this for desktop because we don't have lat/lng-supported pillar pages.
   */
  enableGeoLocation?: boolean,

  /** Prop-drilling */
  latLngUrlTemplate?: ?string,

  /** Prop-drilling */
  geoUrlTemplate?: ?string,

  /** Quick link label for tracking (eg. hotel, attraction, etc.) */
  trackingLabel?: string,

  /** The optional UI name for typeahead tracking events */
  uiOrigin?: string,

  /** Promise for future geopill sponsor result or null if not enabled */
  sponsorDataProvider?: ?GeoPillSponsorDataProvider,

  /** Invoked when the geo pill overlay is opened */
  onOpen?: () => void,

  /** Invoked when the geo pill overlay is closed */
  onClose?: () => void,
|};

const GeoPillFlyout = (props: Props) => (
  /* pre-fetching sponsor data by requesting it on user's click */
  <div onClick={props.sponsorDataProvider}>
    <TargetedFlyout
      onOpen={props.onOpen}
      onClose={props.onClose}
      overlayContents={
        <div className={styles.container} data-test-geopill-contents>
          <GeoPillSearch
            latLngUrlTemplate={props.latLngUrlTemplate}
            geoUrlTemplate={props.geoUrlTemplate}
            // Enable nearby option for all non BU Geopills, or non vacation package BU Geopills
            enableGeoLocation={
              props.enableGeoLocation || !props.trackingLabel || props.trackingLabel !== 'vp'
            }
            trackingLabel={props.trackingLabel}
            sponsorDataProvider={props.sponsorDataProvider}
            uiOrigin={props.uiOrigin}
          />
        </div>
      }
      offsetTop={150}
    >
      {targetRef => props.children(targetRef)}
    </TargetedFlyout>
  </div>
);

export type ConfigProps = React.ElementConfig<typeof GeoPillFlyout>;

export default GeoPillFlyout;
